import { Component } from '@angular/core';

@Component({
    selector: 'lm-privacy',
    templateUrl: 'privacy.component.html'
})

export class PrivacyComponent { }



// WEBPACK FOOTER //
// ./src/app/features/shared/components/privacy/privacy.component.ts